import MainLayout from '../../components/Layout'
import HeroBanner from '../../components/HeroBanner/Manufacturer'

function Banner() {
  return (
    <MainLayout>
      <div className="mx-auto px-5 sm:px-0">
        <div className="flex flex-col items-start">
          <h2 className="events h-[50px] sm:h-auto">Banner</h2>
        </div>
        <div className="mx-auto grid max-w-full divide-y divide-neutral-200">
          <HeroBanner type={'BUY_SADDLE'} />
        </div>
      </div>
    </MainLayout>
  )
}

export default Banner


